import React from 'react'
import {BrowserRouter, Switch, Route} from 'react-router-dom'


import Home from './pages/Home'
import Empreendedorismo from './pages/Empreendedorismo'
import Eventos from './pages/Eventos'
import Noticias from './pages/Noticias'
import Startup from './pages/Startup';
import Editais from './pages/Editais'
import Pesquisa from './pages/Pesquisa'
import Empresarial from './pages/Empresarial'

const Routes = () =>{
    return(
        <BrowserRouter>
            <Switch>
                <Route exact path='/' component={Home} />
                <Route exact path='/empreendedorismo' component={Empreendedorismo} />
                <Route exact path='/pesquisa' component={Pesquisa} />
                <Route exact path='/empresarial' component={Empresarial} />
                <Route exact path='/eventos' component={Eventos}/>
                <Route exact path='/noticias' component={Noticias}/>
                <Route exact path='/startup/:id' component={Startup}/>
                <Route exact path='/editais' component={Editais}/>
            </Switch>
        </BrowserRouter>
    );
}

export default Routes